import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/lib/lang";

export default function Earnings() {
  const [data, setData] = useState(null);
  const { t, lang } = useLang();
  useEffect(() => { api.get("/driver/earnings").then((r) => setData(r.data)); }, []);
  if (!data) return <div className="p-6 text-slate-500">Loading…</div>;
  return (
    <div className="p-5">
      <p className="label-caps mb-1">{t("earnings")}</p>
      <h1 className="font-display text-3xl text-[#0a0f1e]">€{data.month_total.toFixed(2)}</h1>
      <p className="text-sm text-slate-500 mt-1">{t("this_month")}</p>

      <div className="mt-6 grid grid-cols-2 gap-3">
        <div className="border border-[#f59e0b]/30 bg-[#f59e0b]/5 p-4">
          <div className="label-caps mb-2">{t("this_week")}</div>
          <div className="font-display text-2xl text-[#f59e0b]">€{data.week_total.toFixed(2)}</div>
        </div>
        <div className="border border-slate-200 bg-white p-4">
          <div className="label-caps mb-2">{t("this_month")}</div>
          <div className="font-display text-2xl text-[#0a0f1e]">€{data.month_total.toFixed(2)}</div>
        </div>
      </div>

      <div className="mt-8">
        <p className="label-caps mb-3">Completed trips</p>
        <div className="space-y-2">
          {data.trips.length === 0 && <div className="text-xs text-slate-500">No completed trips yet.</div>}
          {data.trips.map((tr) => (
            <div key={tr.id} className="border border-slate-200 p-3 flex justify-between items-center">
              <div>
                <div className="text-xs text-slate-500">{new Date(tr.service_datetime).toLocaleDateString(lang === "PT" ? "pt-PT" : "en-GB", { day: "2-digit", month: "short" })}</div>
                <div className="text-sm text-[#0a0f1e]">{tr.destination_address}</div>
                <div className="text-[10px] uppercase text-slate-500">{tr.type}</div>
              </div>
              <div className="font-display text-lg text-[#f59e0b]">€{tr.driver_earning?.toFixed(2)}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
